/**
 * zel-finance.doseo
 * @since       26.09.2017 19:38
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

import $ from 'jquery';


export default function(selector) {
  let $topper = $(selector);
  let $window = $(window);

  if ($topper.hasClass('is-init')) return;

  $window.on('scroll', e => {
    if ($window.scrollTop() > $window.height()) {
      $topper.addClass('is-active');
    } else {
      $topper.removeClass('is-active');
    }
  });

  $topper.on('click', e => {
    e.preventDefault();

    let timeOut;

    function goUp() {
      let top = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      if (top > 0) {
        window.scrollBy(0, -100);
        timeOut = setTimeout(goUp, 10);
      } else {
        clearTimeout(timeOut);
      }
    }

    goUp();
  });

  $topper.addClass('is-init');
}



// WEBPACK FOOTER //
// ./source/js/components/totop.js